// DCA Enterprises Inc. hosted booking portal links for SEG Career Support.
// Each link opens the DCA portal in a NEW TAB. Booking + payment run through DCA (Stripe).
const DCA_BASE = "https://dcaenterprisesinc.com";

export const DCA_LINKS = {
  // "Choose your session" page — lets the visitor pick the FREE 20-min OR the $150 60-min session.
  // All session CTAs (free or paid) across the site point here.
  session: `${DCA_BASE}/embed/schedule?brand=segcareer`,
  // Back-compat aliases (kept so existing imports keep working). All resolve to the chooser page.
  free20: `${DCA_BASE}/embed/schedule?brand=segcareer`,
  paid60: `${DCA_BASE}/embed/schedule?brand=segcareer`,
  general: `${DCA_BASE}/embed/schedule?brand=segcareer`,
  // Direct per-session deep links (skip the chooser, go straight to that session's booking).
  freeSession: `${DCA_BASE}/embed/schedule?brand=segcareer&service=svc_fb1a06e2e5`,
  paidSession: `${DCA_BASE}/embed/schedule?brand=segcareer&service=svc_cd7ba43574`,

  // Coaching packages overview page (3 / 6 / 12-month).
  packages: `${DCA_BASE}/embed/packages?brand=segcareer`,
  // Per-package direct Stripe payment links (go straight to that package's checkout).
  packages3: `${DCA_BASE}/api/pay/coaching/segcareer/pkg_seg_3mo`,
  packages6: `${DCA_BASE}/api/pay/coaching/segcareer/pkg_seg_6mo`,
  packages12: `${DCA_BASE}/api/pay/coaching/segcareer/pkg_seg_12mo`,
};

// Maps a SEG coaching-package id (from servicesData.js) to its DCA enroll deep-link.
export const PACKAGE_ENROLL_LINKS = {
  "3-month": DCA_LINKS.packages3,
  "6-month": DCA_LINKS.packages6,
  "executive": DCA_LINKS.packages12,
};
